import { createApp } from 'vue';
import App from './App.vue';
import router from './routers';
import store from './store';
import VueDaumPostcode from 'vue-daum-postcode';
import VueCookies from 'vue-cookies';
import FilterUtils from './util/filters';
import { pushQueryString, pushHistoryState } from './util/routerUtils';
import scrollUp from './util/scrollUp';
import openUrl from './util/openUrl';
import vuetify from './plugins/vuetify';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import '@/assets/sass/components/_button.scss';
import '@/assets/sass/components/_common.scss';
import '@/assets/sass/components/_table.scss';
import '@/assets/sass/layout/_contents.scss';
import '@/assets/sass/layout/_footer.scss';
import '@/assets/sass/layout/_header.scss';
import '@/assets/sass/layout/_mainpage.scss';
import { createHead } from '@vueuse/head';

const app = createApp(App)
  .use(router)
  .use(vuetify)
  .use(store)
  .use(VueDaumPostcode)
  .use(VueCookies)
  .use(VueDatePicker)
  .use(createHead());

app.$cookies.config('1d');

app.config.globalProperties.$filters = FilterUtils;

app.config.globalProperties.$pushQueryString = pushQueryString;
app.config.globalProperties.$pushHistoryState = pushHistoryState;
app.config.globalProperties.$scrollUp = scrollUp;
app.config.globalProperties.$openUrl = openUrl;

app.mount('#app');
